import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * 主要用于瓦片图层队列的渲染
 */
export var TileRenderService = /*#__PURE__*/function () {
  function TileRenderService(rendererService) {
    _classCallCheck(this, TileRenderService);

    this.rendererService = rendererService;
  }

  _createClass(TileRenderService, [{
    key: "render",
    value: function render(layers) {
      var _this = this;

      layers.filter(function (layer) {
        return layer.inited;
      }).filter(function (layer) {
        return layer.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeRenderData.call();
        layer.hooks.beforeRender.call();

        if (layer.masks.length > 0) {
          // 清除上一次的模版缓存
          _this.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });

          layer.masks.map(function (m) {
            m.hooks.beforeRenderData.call();
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.render();
        layer.hooks.afterRender.call();
      });
    }
  }, {
    key: "renderMask",
    value: function renderMask(layer) {
      if (layer.inited && layer.isVisible() && layer.masks.length > 0) {
        layer.hooks.beforeRender.call();
        this.rendererService.clear({
          stencil: 0,
          depth: 1,
          framebuffer: null
        });
        layer.masks.map(function (m) {
          m.hooks.beforeRender.call();
          m.render();
          m.hooks.afterRender.call();
        });
        layer.hooks.afterRender.call();
      }
    }
  }]);

  return TileRenderService;
}();